import React from "react";

interface PreloaderProps {
  message: string;
}

const Preloader: React.FC<PreloaderProps> = ({ message }) => {
  return (
    <div id={"preloader"}>
    <h2>{message}</h2>
    <span className="wave" role="img" aria-label="wave">💜</span>
  </div>
  );
}

export default Preloader;
